import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Alerts } from '../models';
import { MessageService } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  private apiUrl: string = environment.apiUrl + '/alerts';

  constructor(private httpClient: HttpClient) {}

  getAlerts() {
    return this.httpClient.get<Alerts>(`${this.apiUrl}`);
  }

  acknowledgeLtoAlert() {
    return this.httpClient.post(
      `${this.apiUrl}/acknowledge?type=New Item`,
      {},
    );
  }
}
